export const SET_TOKEN = 'session/SET_TOKEN';
export const CLEAR_TOKEN = 'session/CLEAR_TOKEN';
